import { API_ADMIN_URL } from "../../../config/constants";
import { postRequest } from "../../API";

function buildResult(res) {
  if (res?.status === true || res?.status === 200) {
    const response = res?.data?.response || {};
    if (response.status === false) {
      return {
        status: false,
        message:
          response.statusMessage ||
          response.response?.error ||
          response.response?.message ||
          "Request failed.",
      };
    }
    return {
      status: true,
      result: response.result,
      count: response.count,
      nextCursor: response.nextCursor,
      games: response.games,
      filter_type: response.filter_type,
      from_date: response.from_date,
      to_date: response.to_date,
      timezone: response.timezone,
      target_rtp: response.target_rtp,
      limits: response.limits,
      raw: response,
    };
  }

  const apiMessage =
    res?.response?.data?.statusMessage ||
    res?.response?.data?.response?.error ||
    res?.response?.data?.message ||
    res?.message;

  return {
    status: false,
    message: apiMessage || "Under Maintenance, Please try after some time.",
  };
}

async function postAdmin(path, options = {}) {
  try {
    const params = {
      url: `${API_ADMIN_URL}smart-rtp/${path}`,
      postData: options,
    };
    const res = await postRequest(params);
    return buildResult(res);
  } catch (error) {
    return {
      status: false,
      message: "Under Maintenance, Please try after some time.",
    };
  }
}

export const getDashboardSummary = async (options = {}) => postAdmin("reports/summary", options);
export const getHourlyReport = async (options = {}) => postAdmin("reports/hourly", options);
export const getGameWiseReport = async (options = {}) => postAdmin("reports/game-wise", options);
export const getPoolReconciliation = async (options = {}) => postAdmin("reports/pool-reconciliation", options);
export const getRtpVariance = async (options = {}) => postAdmin("reports/rtp-variance", options);
export const getSavedReports = async (options = {}) => postAdmin("reports/list", options);
export const getReportDetails = async (options = {}) => postAdmin("reports/details", options);
export const generateReports = async (options = {}) => postAdmin("reports/generate", options);
export const getAuditLogs = async (options = {}) => postAdmin("audit/list", options);
export const getRuntimeLogs = async (options = {}) => postAdmin("logs/list", options);

export const getGamesList = async (options = {}) => postAdmin("games/list", options);
export const getGameById = async (editId) =>
  postAdmin("games/list", { type: "single", condition: { _id: editId } });
export const saveGame = async (options = {}) => postAdmin("games/addeditdata", options);
export const changeGameStatus = async (options = {}) => postAdmin("games/change-status", options);
export const changeGameDrawDate = async (options = {}) => postAdmin("games/change-draw-date", options);

export const getPoolsList = async (options = {}) => postAdmin("prize-pools/list", options);
export const getPoolById = async (editId) =>
  postAdmin("prize-pools/list", { type: "single", condition: { _id: editId } });
export const savePool = async (options = {}) => postAdmin("prize-pools/addeditdata", options);
export const adjustPoolBalance = async (options = {}) => postAdmin("prize-pools/adjust-balance", options);
export const reconcilePool = async (options = {}) => postAdmin("prize-pools/reconcile", options);

export const getSlabsList = async (options = {}) => postAdmin("prize-slabs/list", options);
export const getSlabById = async (editId) =>
  postAdmin("prize-slabs/list", { type: "single", condition: { _id: editId } });
export const getSlabsBoard = async (options = {}) => postAdmin("prize-slabs/board", options);
export const saveSlabsBoard = async (options = {}) => postAdmin("prize-slabs/bulk-save", options);
export const saveSlab = async (options = {}) => postAdmin("prize-slabs/addeditdata", options);

export const getBuyerRewardRules = async (options = {}) => postAdmin("consecutive-loss/list", options);
export const getBuyerRewardRuleById = async (editId) =>
  postAdmin("consecutive-loss/list", { type: "single", condition: { _id: editId } });
export const saveBuyerRewardRule = async (options = {}) => postAdmin("consecutive-loss/addeditdata", options);

export const getOrdersList = async (options = {}) => postAdmin("orders/list", options);
export const getOrderDetails = async (options = {}) => postAdmin("orders/details", options);
export const cancelOrder = async (options = {}) => postAdmin("orders/cancel", options);
export const setOrderRePrint = async (options = {}) => postAdmin("orders/enable-reprint", options);

export const getBuyersList = async (options = {}) => postAdmin("buyers/list", options);
export const getBuyerDetails = async (options = {}) => postAdmin("buyers/details", options);

export const getRewardsList = async (options = {}) => postAdmin("rewards/list", options);
export const assignManualBigPrize = async (options = {}) => postAdmin("rewards/manual-big-prize", options);
export const adminRedeemWinner = async (options = {}) => postAdmin("rewards/admin-redeem", options);

export const getWinnersDaySummary = async (options = {}) =>
  postAdmin("rewards/winners/day-summary", options);
export const getWinnersDailySummaries = async (options = {}) =>
  postAdmin("rewards/winners/daily", options);
export const getWinnersList = async (options = {}) => postAdmin("rewards/winners/list", options);

export const getSettingsList = async (options = {}) => postAdmin("settings/list", options);
export const getSettingsById = async (editId) =>
  postAdmin("settings/list", { type: "single", condition: { _id: editId } });
export const saveSettings = async (options = {}) => postAdmin("settings/addeditdata", options);
export const changeSettingsStatus = async (options = {}) => postAdmin("settings/change-status", options);
export const clearTodayBigPrizes = async (options = {}) =>
  postAdmin("settings/clear-today-big-prizes", options);

export const getBigPrizeMonitorList = async (options = {}) =>
  postAdmin("settings/big-prize-monitor/list", options);
export const deleteBigPrizeAward = async (options = {}) =>
  postAdmin("settings/big-prize-monitor/delete-award", options);
export const inactiveBigPrizePos = async (options = {}) =>
  postAdmin("settings/big-prize-monitor/inactive-pos", options);
export const inactiveBigPrizeConfig = async (options = {}) =>
  postAdmin("settings/big-prize-monitor/inactive-config", options);

export const getBigPrizeBulkList = async (options = {}) =>
  postAdmin("settings/big-prize-bulk/list", options);
export const saveBigPrizeBulk = async (options = {}) =>
  postAdmin("settings/big-prize-bulk/save", options);

export const getBigPrizeBulkHistoryList = async (options = {}) =>
  postAdmin("settings/big-prize-bulk/history/list", options);
export const getBigPrizeBulkHistoryDetails = async (options = {}) =>
  postAdmin("settings/big-prize-bulk/history/details", options);
export const getBigPrizeDaySummary = async (options = {}) =>
  postAdmin("settings/big-prize-bulk/day-summary", options);
export const getBigPrizeDailySummary = async (options = {}) =>
  postAdmin("settings/big-prize-bulk/daily-summary", options);

export const predictPrizeDistribution = async (options = {}) =>
  postAdmin("reports/predict-distribution", options);
